<script lang="ts" setup>
defineProps<{ rating: Rating }>()
</script>

<template>
  <aside v-if="rating && rating > 0" class="inline-flex items-center gap-2">
    <Stars :stars="rating" class="text-yellow" />
    <p class="flex items-baseline uppercase font-display">
      <span class="font-bold text-lg md:text-xl lg:text-2xl xl:text-3xl">{{ rating }}</span> / 5
    </p>
  </aside>
</template>
